type ActiveStatus = {
  isActive?: boolean;
};

export default function orderByActiveStatus<T extends ActiveStatus>(options: T[]) {
  const activeOptions = options.filter((option) => option.isActive !== false);
  const inactiveOptions = options.filter((option) => option.isActive === false);

  return [...activeOptions, ...inactiveOptions];
}
